<template>
  <div class="wrapper">
    <div class="widget">
      <div class="whead">
        <h6><Icon :type="icon" /> {{ title }}</h6>
      </div>
      <div class="list-header-opers">
        <slot name="toolbar">
          <mButton type="ghost" class="list-header-oper-button"
                  v-for="(item, index) in opers"
                  :key="index"
                  size="s"
                  v-if="item.operShowPosition !== 'table'"
                  @click="toolbarCallFn(item)"
                  :icon="item.iconClass">
            <span>{{ item.title }}</span>
          </mButton>
        </slot>
      </div>
      <div class="list-hidden-query" v-if="isShowQuery">
        <a class="query-option " :class="{'active':showQuery}" @click="showQuery = !showQuery">
          <Icon custom="ivu-img-16 ivu-img-search2" />
        </a>
        <transition name="trans-fade">
          <div class="list-content-query" v-show="showQuery">
            <slot name="query">

            </slot>
          </div>
        </transition>
      </div>
      <div class="list-content-table">
        <slot name="table"></slot>
      </div>
      <div class="list-footer-page">
        <slot name="page">

        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import mButton from '@/components/button/m-button'
    export default {
      name: "wrapper-list",
      props:{
        wIcon:{
          type:String
        },
        wTitle:{
          type:String
        },
        isShowQuery:{
          type:Boolean,
          default:true

        }
      },
      data() {
        return {
          title:this.wTitle,
          icon:this.wIcon,
          func: {}, //功能
          opers:[],
          showQuery:true
        }
      },
      components:{mButton},
      /**
       * 使用该组件一般都是
       * */
      created(){
        let funcId = this.$route.query.paasCurrentFunctionId;
        if(funcId===undefined){
          funcId = this.$store.state.defaultFuncId;
        }
        let funcOperMap = this.$store.state.funcOperMap;
        if(JSON.stringify(funcOperMap) !== {} && window.localStorage.getItem("funcOperMap")){
            funcOperMap = JSON.parse(window.localStorage.getItem("funcOperMap"));
            this.$store.commit('setFuncOperMap', funcOperMap);
        }
        if(funcOperMap){
          this.func = funcOperMap[funcId].func;
          if(this.isEmpty(this.wIcon)){
            this.icon = this.func.iconClass;
          }
          if(this.isEmpty(this.wTitle)){
            this.title = this.func.title;
          }
          this.opers = funcOperMap[funcId].opers;
        }
      },
      methods:{
        toolbarCallFn(item){
          this.$emit(item.operCode);
        },
        isEmpty(item){
          let flag = false;
          if(item === null || item === "" || item === "undefined" || item === undefined || item === "null"){
            flag = true;
          }
          return flag;
        }
      },
      watch:{
        /**
         * 显示查询的同时 计算表格的高度
         */
        showQuery(val){
          if(!val){
            setTimeout(()=>{
              this.$emit("calculate",val);
            },1000)
          }else{
            this.$emit("calculate",val);
          }
        }
      }
    }
</script>

<style scoped>
  @import "../../assets/css/meta-list.css";
</style>
